import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Award } from 'lucide-react';

interface DistinctionBadgeProps {
  score: number;
  size?: 'sm' | 'md' | 'lg';
  showIcon?: boolean;
}

export const DistinctionBadge: React.FC<DistinctionBadgeProps> = ({ 
  score, 
  size = 'md',
  showIcon = true 
}) => {
  if (score <= 100) return null;

  const sizeClasses = {
    sm: 'text-xs px-2 py-1',
    md: 'text-sm px-3 py-1',
    lg: 'text-base px-4 py-2'
  };

  const iconSizes = {
    sm: 'h-3 w-3',
    md: 'h-4 w-4', 
    lg: 'h-5 w-5'
  };

  return (
    <Badge className={`bg-gradient-to-r from-amber-400 to-yellow-500 text-amber-900 border-amber-300 ${sizeClasses[size]} font-semibold shadow-sm`}>
      {showIcon && <Award className={`${iconSizes[size]} mr-1`} />}
      Distinction
    </Badge>
  );
};